<div id="side-bar" class="hidden-sm hidden-xs">
    <div class="row-custom">
        <div class="col-xs-12">
            <h1>Cadastrar Nova Ficha</h1>
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12">
            <div class="cover-link"></div>
            <ul class="nav nav-tabs nav-stacked wizard" role="tablist">
                <li role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_VENDEDOR,
                                                      'done': fichaCadastro.passo >= fichaCadastro.PASSO_CLIENTE}">
                    <a aria-controls="formA" role="tab" data-toggle="tab">
                        Vendedor
                        <span>1</span>
                    </a>
                </li>
                <li role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_CLIENTE,
                                                      'done': fichaCadastro.passo >= fichaCadastro.PASSO_VEICULO}">
                    <a aria-controls="formB" role="tab" data-toggle="tab">
                        Cliente
                        <span>2</span>
                    </a>
                </li>
                <li role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_VEICULO_PROPRIO,
                                                      'done': fichaCadastro.passo >= fichaCadastro.PASSO_CONSULTANDO_DADOS}">
                    <a href="#formC" aria-controls="formC" role="tab" data-toggle="tab">
                        Veículo
                        <span>3</span>
                    </a>
                </li>
                <li role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_CONSULTANDO_DADOS,
                                                      'done': fichaCadastro.passo >= fichaCadastro.PASSO_RESULTADO_PARCIAL}">
                    <a href="#formD" aria-controls="formD" role="tab" data-toggle="tab">
                        Consultando Dados
                        <span>4</span>
                    </a>
                </li>
                <li role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_RESULTADO_PARCIAL,
                                                      'done': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_CLIENTE}">
                    <a href="#formD" aria-controls="formD" role="tab" data-toggle="tab">
                        Resultado Parcial
                        <span>5</span>
                    </a>
                </li>
                <li *ngIf="!fichaCadastro.hasAvalista()" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_CLIENTE,
                                                                                           'done': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_CLIENTE}">
                    <a href="#formE" aria-controls="formE" role="tab" data-toggle="tab">
                        + Detalhes Cliente
                        <span>6</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.hasAvalista()" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_CLIENTE,
                                                                                          'done': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA}">
                    <a href="#formE" aria-controls="frmE" role="tab" data-toggle="tab">
                        + Detalhes Cliente
                        <span>6</span>
                    </a>
                </li>
                <li
                    *ngIf="fichaCadastro.hasAvalista() && fichaCadastro.avalistas.length === 0 || fichaCadastro.avalistas.length === 1"
                    role="presentation"
                    [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA, 'done': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_CLIENTE}">
                    <a href="#formEA" aria-controls="formE" role="tab" data-toggle="tab">
                        + Detalhes Avalista
                        <span>7</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length > 1" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA,
                                                                                                   'done': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA_2}">
                    <a href="#formEA" aria-controls="formE" role="tab" data-toggle="tab">
                        + Detalhes Avalista 1
                        <span>7</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length === 2" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA_2,
                                                                                                 'done': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_CLIENTE}">
                    <a href="#formEA" aria-controls="formE" role="tab" data-toggle="tab">
                        + Detalhes Avalista 2
                        <span>8</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length > 2" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA_2,
                                                                                                 'done': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA_3}">
                    <a href="#formEA" aria-controls="formE" role="tab" data-toggle="tab">
                        + Detalhes Avalista 2
                        <span>8</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length > 2" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_DETALHE_AVALISTA_3,
                                                                                                 'done': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_CLIENTE}">
                    <a href="#formEA" aria-controls="formE" role="tab" data-toggle="tab">
                        + Detalhes Avalista 3
                        <span>9</span>
                    </a>
                </li>
                <li *ngIf="!fichaCadastro.hasAvalista()" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_CLIENTE,
                                                                                           'done': fichaCadastro.passo >= fichaCadastro.PASSO_OBSERVACAO}">
                    <a href="#formF" aria-controls="formF" role="tab" data-toggle="tab">
                        Endereços Cliente
                        <span>7</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.hasAvalista()" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_CLIENTE,
                                                                                          'done': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA}">
                    <a href="#formF" aria-controls="formF" role="tab" data-toggle="tab">
                        Endereços Cliente
                        <span *ngIf="fichaCadastro.avalistas.length === 0">8</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 1">8</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 2">9</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 3">10</span>
                    </a>
                </li>
                <li
                    *ngIf="fichaCadastro.hasAvalista() && fichaCadastro.avalistas.length === 0 || fichaCadastro.avalistas.length === 1"
                    role="presentation"
                    [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA, 'done': fichaCadastro.passo >= fichaCadastro.PASSO_OBSERVACAO}">
                    <a href="#formFA" aria-controls="formFA" role="tab" data-toggle="tab">
                        Endereços Avalista
                        <span>9</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length > 1" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA,
                                                                                                 'done': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA_2}">
                    <a href="#formFA" aria-controls="formFA" role="tab" data-toggle="tab">
                        Endereços Avalista 1
                        <span *ngIf="fichaCadastro.avalistas.length === 2">10</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 3">11</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length === 2" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA_2,
                                                                                                   'done': fichaCadastro.passo >= fichaCadastro.PASSO_OBSERVACAO}">
                    <a href="#formFA" aria-controls="formFA" role="tab" data-toggle="tab">
                        Endereços Avalista 2
                        <span>11</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length > 2" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA_2,
                                                                                                 'done': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA_3}">
                    <a href="#formFA" aria-controls="formFA" role="tab" data-toggle="tab">
                        Endereços Avalista 2
                        <span>12</span>
                    </a>
                </li>
                <li *ngIf="fichaCadastro.avalistas.length > 2" role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ENDERECO_AVALISTA_3,
                                                                                                 'done': fichaCadastro.passo >= fichaCadastro.PASSO_OBSERVACAO}">
                    <a href="#formFA" aria-controls="formFA" role="tab" data-toggle="tab">
                        Endereços Avalista 3
                        <span>13</span>
                    </a>
                </li>
                <li role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_OBSERVACAO,
                                                      'done': fichaCadastro.passo >= fichaCadastro.PASSO_ANALISE}">
                    <a href="#formG" aria-controls="formG" role="tab" data-toggle="tab">
                        Observações
                        <span *ngIf="!fichaCadastro.hasAvalista()">8</span>
                        <span *ngIf="fichaCadastro.hasAvalista() && fichaCadastro.avalistas.length === 0">10</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 1">10</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 2">12</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 3">14</span>

                    </a>
                </li>
                <li role="presentation" [ngClass]="{'active': fichaCadastro.passo >= fichaCadastro.PASSO_ANALISE,
                                                      'done': fichaCadastro.passo >= fichaCadastro.PASSO_ANALISE}">
                    <a href="#formH" aria-controls="formH" role="tab" data-toggle="tab">
                        Análise
                        <span *ngIf="!fichaCadastro.hasAvalista()">9</span>
                        <span *ngIf="fichaCadastro.hasAvalista() && fichaCadastro.avalistas.length === 0">11</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 1">11</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 2">13</span>
                        <span *ngIf="fichaCadastro.avalistas.length === 3">15</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
